/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';

const KeyboardExtraBarButton = props => {
  const text = props.intl.formatMessage({
    id: props.label,
  });
  return (
    <button
      className={'keb-button'}
      title={text}
      onClick={() => {
        props.onClick(text);
      }}
    >
      <FormattedMessage id={props.label} />
    </button>
  );
};

KeyboardExtraBarButton.propTypes = {
  intl: PropTypes.object,
  label: PropTypes.string,
  onClick: PropTypes.func,
};

export default injectIntl(KeyboardExtraBarButton);
